export default __webpack_public_path__ + "static/card-5-0a6064ada34ade886b8667b036e6efcc.png";